
import { asyncLoadJs } from './util.client'
// 压缩图片
/**
 * quality 图片压缩质量，满分为1
 */
export const Compressor = async(file:any, quality = 0.8) => {
  await asyncLoadJs('/js/image-compressor.min.js', { id: 'image-compressor', ready: () => typeof window.ImageCompressor === 'function' })
  return new Promise((resolve) => {
    // Compressor options
    var options = {
        file: file,
        quality: quality,
        old_size: 0,
        old_file: null,

        // Compressor before callback
        beforeCompress: function (result:any) {
          options.old_size = result.size
          options.old_file = result
        },

        // Canvas after callback
        afterDraw: function (ctx:any, canvas:any) {
          ctx.restore()
        },

        // Compressor success callback
        success: function (result:any) {
          if(options.old_size < result.size) {
            resolve(options.old_file)
          }
          // Blob convert file
          const newFile = new window.File([result], result.name, {
            type: result.type
          })
         
          // return new file
          resolve(newFile)
        },
    }

    // Call compressor api 
    new window.ImageCompressor(options)
  })
}
export default defineNuxtPlugin(async (NuxtApp) => {
  const provide = { 
    Compressor
  }

  return { provide }
})
